import {HTTP, ERROR} from '@/http-common';
import {ProgramStatus} from "../../enums/programStatus";

const state = {
  loading: false,
  availablePrograms: [],
  childrenAccounts: []
};

const mutations = {
  SET_LOADING(state, data) {
    state.loading = data
  },
  SET_AVAILABLE_PROGRAMS(state, data) {
    state.availablePrograms = data
  },
  SET_CHILDREN_ACCOUNTS(state, data) {
    state.childrenAccounts = data
  },
};

const getters = {
  getLoading: state => state.loading,
  getAvailablePrograms: state => state.availablePrograms,
  getChildrenAccounts: state => state.childrenAccounts,
  getActiveAvailablePrograms: state => state.availablePrograms.filter(p => p.status === ProgramStatus.ACTIVE),
};

const actions = {
  fetchAvailablePrograms: ({commit, state}, {accountId}) => {
    HTTP.get('/accounts/' + accountId + '/programs').then(response => {
      ERROR(response);
      commit('SET_AVAILABLE_PROGRAMS', response.data.data.programs);
    }).catch(error => {
      console.log(error);
    });
  },
  fetchChildrenAccounts: ({commit, state}, {accountId}) => {
    return HTTP.get('/accounts/edit/' + accountId).then((response) => {
      ERROR(response);
      let accounts = response.data.data.account.childrenAccounts;
      accounts.push({
        id: response.data.data.account.id,
        organizationName: response.data.data.account.organizationName
      });
      accounts.sort((a, b) => (a.organizationName > b.organizationName ? 1 : -1));
      commit('SET_CHILDREN_ACCOUNTS', accounts);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/formBuilderEditor.js